import React from 'react';
import PropTypes from 'prop-types';
import ErrorTemplateBody from './ErrorTemplateBody';

var MethodNotAllowed405Page = React.forwardRef(function (props, ref) {
    var edsContext = props.edsContext;

    var errorTitle = edsContext.formatMessage('component.ErrorPage.405');
    var errorMessage = edsContext.formatMessage('component.ErrorPage.405.message');

    return React.createElement(ErrorTemplateBody, Object.assign({
        largeIllustrationName: '403.png',
        errorTitle: errorTitle,
        errorMessage: errorMessage
    }, props, {
        ref: ref
    }));
});

MethodNotAllowed405Page.propTypes = {
    edsContext: PropTypes.object
};

export default MethodNotAllowed405Page;